export default __webpack_public_path__ + "static/inst8-606111e6dd183d9a0e822b8edc4f5617.png";